import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

/**
 * Presents the content of a {@link ents.core.summit.CheckIn}
 */
@ngCore.Component({
  imports: [ds.input.textArea.Component],
  selector: 'atn-check-in-modal-content',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.checkIn.Feature} */
  public readonly checkInFeature = ngCore.inject(state.summit.checkIn.Feature)
}
